export const css = {
	root: '_3VpDoxQL',
	title: '_1FpLFfDo',
	cards: '_3Qq-DFcd',
	studyplan: '_1dj4g9hU',
	' _key': 'ascm-theme/ascm/explore-view/chooser'
};

export default css;
